
import React, { useState } from 'react';
import { Book } from 'lucide-react';
import QuizCard from '@/components/QuizCard';
import ProgressBar from '@/components/ProgressBar';
import QuizResults from '@/components/QuizResults';
import TopicSelector from '@/components/TopicSelector';
import { useQuiz } from '@/context/QuizContext';

const Index = () => {
  const { 
    currentQuestion, 
    currentQuestionIndex, 
    topics, 
    currentTopic, 
    nextQuestion, 
    handleAnswer, 
    correctAnswers, 
    isComplete, 
    topicQuestions, 
    setCurrentTopic, 
    resetQuiz 
  } = useQuiz();

  const handleBackToTopics = () => {
    setCurrentTopic(null);
  };

  return (
    <div className="min-h-screen bg-background px-4 py-8 md:py-12">
      <header className="max-w-4xl mx-auto text-center mb-12">
        <div className="inline-flex items-center justify-center p-2 bg-primary/10 rounded-full mb-4">
          <Book className="h-6 w-6 text-primary" />
        </div>
        <h1 className="text-4xl md:text-5xl font-serif font-bold mb-3">
          Al-Ajrumiyyah Quizzer
        </h1>
        <p className="arabic-subtitle text-center mb-2">
          المُقَدِّمَةُ الآجُرُّومِيَّةُ في مَبَادِئِ عِلْمِ العَرَبِيَّةِ
        </p>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Test your knowledge of classical Arabic grammar with these practice questions based on the famous Al-Ajrumiyyah text.
        </p>
      </header>

      <main className="max-w-4xl mx-auto pb-12">
        {!currentTopic ? (
          <TopicSelector topics={topics} onSelectTopic={setCurrentTopic} />
        ) : (
          <>
            {!isComplete ? (
              <>
                <ProgressBar 
                  current={currentQuestionIndex + 1} 
                  total={topicQuestions.length} 
                  correctAnswers={correctAnswers}
                />
                
                {currentQuestion && (
                  <QuizCard 
                    question={currentQuestion}
                    onNext={nextQuestion}
                    onAnswer={handleAnswer}
                    isLast={currentQuestionIndex === topicQuestions.length - 1}
                    onBackToTopics={handleBackToTopics}
                  />
                )}
              </>
            ) : (
              <QuizResults 
                correctAnswers={correctAnswers}
                totalQuestions={topicQuestions.length}
                onRetry={resetQuiz}
                onNewTopic={handleBackToTopics}
              />
            )}
          </>
        )}
      </main>

      <footer className="mt-auto text-center text-sm text-muted-foreground py-6">
        <p>© {new Date().getFullYear()} Trying to be a better seminary student. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Index;
